import React, { useContext, useEffect, useMemo, useReducer } from 'react';
import { useStateFromUrl } from 'seagull/utils/useStateFromUrl';
import { DeclarativeModal } from 'seagull';
import FullPageInvoice from "./FullPageInvoice";
import { invoiceSearchParam, relationshipSearchParam } from "./FullPageInvoice.utils";
const noop = () => {};
const OnRefreshContext = /*#__PURE__*/React.createContext({
  registerOnRefresh: noop,
  unregisterOnRefresh: noop
});
function reducer(state, action) {
  if (action.type === 'add') {
    return state.concat({
      id: action.id,
      callback: action.callback
    });
  } else {
    return state.filter(_ref => {
      let {
        id
      } = _ref;
      return id !== action.id;
    });
  }
}
export function useFullPageInvoiceOnRefresh() {
  return useContext(OnRefreshContext);
}
export default function FullPageInvoiceOpener(props) {
  const {
    urlState: {
      invoice,
      relationship
    },
    changeUrlState
  } = useStateFromUrl({
    [invoiceSearchParam]: {
      defaultValue: ''
    },
    [relationshipSearchParam]: {
      defaultValue: ''
    }
  });
  const [onRefreshCallbacks, dispatch] = useReducer(reducer, []);
  const value = useMemo(() => {
    return {
      registerOnRefresh(id, callback) {
        dispatch({
          type: 'add',
          id,
          callback
        });
      },
      unregisterOnRefresh(id) {
        dispatch({
          type: 'remove',
          id
        });
      }
    };
  }, []);
  useEffect(() => {
    if (invoice && !relationship) {
      changeUrlState({
        invoice: ''
      });
    } else if (!invoice && relationship) {
      changeUrlState({
        relationship: ''
      });
    }
  }, [invoice, relationship]);
  const content = _ref2 => {
    let {
      dismissModal
    } = _ref2;
    return /*#__PURE__*/React.createElement(FullPageInvoice, {
      invoiceId: invoice,
      relationshipId: relationship,
      dismissModal: dismissModal,
      onRefresh: options => Promise.all(onRefreshCallbacks.map(_ref3 => {
        let {
          callback
        } = _ref3;
        return callback(options);
      }))
    });
  };
  return /*#__PURE__*/React.createElement(OnRefreshContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(DeclarativeModal, {
    isOpen: !!(invoice && relationship),
    content: props.content || content,
    onClose: () => {
      changeUrlState({
        invoice: '',
        relationship: ''
      }, {
        push: true
      });
    }
  }), props.children);
}